import axios from './../../config/axios';

/**
 * @typedef {{
 *      data: {
 *          id: number
 *          name: string
 *          start_at:string 
 *          end_at: string
 *          vehicle_id: number
 *      }
 * }} VehicleLicense
 */

/**
 * Find the latest vehicle license by providing the vehicle id
 * @param {Number} id Vehicle ID 
 * @returns {Promise<VehicleLicense>}
 */
function findByVehicleId(id) {
    if(isNaN(id)) {
        throw new Error("vehicle id should be a number");
    }
    let vehId = Number(id)
    return axios().get(`/license/current-vehicle-license/${vehId}`)
}

/**
 * Find the vehicle license by vehicle id
 * @param {Number} id 
 * @returns {Promise<VehicleLicense>}
 */
function find(id) {
    return axios().get(`/license/vehicle-licenses/${id}`);
}

/**
 * Create license for the vehicle
 * @param {VehicleLicense} data 
 * @returns {Promise<VehicleLicense>}
 */
function create(data) {
    return axios().post(`/license/vehicle-licenses`, data);
}

/**
 * Update license for the vehicle
 * @param {VehicleLicense} data 
 * @returns {Promise<VehicleLicense>}
 */
function update(data) {
    return axios().post(`/license/vehicle-licenses/${data.id}`, data);
}

/**
 * Remove license for the vehicle
 * @param {number} id 
 * @returns {Promise<VehicleLicense>}
 */
function remove(id) {
    return axios().post(`/license/vehicle-licenses/${id}`);
}


export default {
    findByVehicleId,
    find,
    create,
    update,
    remove
}